export * from './pergunta-cartorio.model';
export * from './usuario-cartorio.model';
export * from './horario-atendimento.model';
export * from './agendamento-atendimento.model';
export * from './resposta-atendimento.model';
export * from './expediente-cartorio.model';
